module.exports = __webpack_public_path__ + "img/info.296d14d4.svg";